module.exports = __webpack_public_path__ + "static/media/portero.3119f5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/moho_blanco_papa/curativa/portero.png
// module id = 1998
// module chunks = 3